"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppEffects = void 0;
const utils_1 = require("@obvio/utils");
const router_1 = require("next/router");
const react_1 = require("react");
const gtag_1 = require("./gtag");
const locales_1 = require("./locales");
const storage_1 = require("./storage");
const constants_1 = require("../constants");
const env_1 = require("../env");
function AppEffects({ children, router, }) {
    (0, react_1.useEffect)(() => {
        const handleRouteChange = (url) => gtag_1.gtag.pageview(url);
        router_1.Router.events.on('routeChangeComplete', handleRouteChange);
        (0, storage_1.setCookie)('timeZone', {
            value: (0, utils_1.getTimezone)(),
            ttl: '7d',
        });
        return () => router_1.Router.events.off('routeChangeComplete', handleRouteChange);
    }, []);
    (0, react_1.useEffect)(() => {
        router.beforePopState((state) => {
            if (utils_1.unloadLock.isEnabled()) {
                if ((state === null || state === void 0 ? void 0 : state.index) === utils_1.unloadLock.historyIndex) {
                    return false;
                }
                if (typeof utils_1.unloadLock.historyIndex === 'number' &&
                    typeof (state === null || state === void 0 ? void 0 : state.index) === 'number') {
                    window.history.go(utils_1.unloadLock.historyIndex - state.index);
                    utils_1.unloadLock.callback(state.index);
                    return false;
                }
                console.error(`ERROR: Unable to prevent popState. Missing index.`);
            }
            return true;
        });
    }, [router]);
    (0, react_1.useEffect)(() => {
        const lang = (0, locales_1.getLangFromPathname)(router.pathname);
        const localeDomain = env_1.STAGE === 'production' &&
            lang !== constants_1.DEFAULT_LANG &&
            constants_1.LOCALE_DOMAINS[lang];
        const { host, pathname, search } = window.location;
        if (localeDomain && host !== localeDomain) {
            const path = pathname.replace(new RegExp(`/${lang}/?`, 'u'), '/');
            window.location.href = `https://${localeDomain}${path}${search}`;
        }
    }, [router.pathname]);
    return children;
}
exports.AppEffects = AppEffects;
